<template lang="pug">
label.toggle-component(:class="`${disable ? 'disabled' : ''} ${value ? 'active' : ''}`")
  .icon(v-if="icon")
    i.mdi(:class="[`mdi-${icon}`]")
  .text
    span {{ text }}
    .tooltip(v-if="tooltip")
      i.mdi.mdi-help-circle
      .tooltiptext(v-if="tooltip", v-html="parseTooltip")
  .switch
    input(type="checkbox", @change="emit($event.target.checked)", :checked="currentValue")
    span.slider
  .explanation(v-if="explanation") {{ explanation }}
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: false,
    },
    text: {
      type: String,
      required: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
    explanation: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    parseTooltip() {
      return this.tooltip.split('\n').reduce((tip, line) => `${tip}<p>${line}</p>`);
    },
  },
  methods: {
    /**
     * Emit the current value from the input
     * @param {Boolean} bool
     */
    emit(bool) {
      if (this.disable) {
        return;
      }
      this.$emit('change', bool);
    },
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue;
    },
  },
  data() {
    return {
      currentValue: false,
    };
  },
  mounted() {
    this.currentValue = this.value;
  },
};
</script>

<style lang="sass" scoped>
.toggle-component
  align-items: center
  display: flex
  flex-wrap: wrap
  line-height: 1
  font-weight: 400
  white-space: normal
  line-height: 18px
  text-transform: none
  position: relative
  min-height: 24px
  &:hover
    cursor: pointer
  &.group
    background-color: #FBFCFC
    position: relative
    padding: 16px 72px 16px 16px
    border: 1px solid #F1F2FA
    border-radius: 4px
    transition: background-color .3s, border-color .3s
    &.active
      background-color: #F4F9FF
      border: 1px solid #94B5EA
    .switch
      position: absolute
      top: 50%
      transform: translateY(-50%)
      right: 16px
    &.disabled
      opacity: .6
      label.switch
        opacity: 1
  &.disabled
    pointer-events: none
    label.switch
      opacity: .6
  &.small
    .switch
      height: 16px
      width: 30px
    .slider:before
      height: 8px
      width: 8px
    input
      &:checked + .slider
        background-color: #35acdd
        &:before
          -webkit-transform: translateX(14px)
          -ms-transform: translateX(14px)
          transform: translateX(14px)
    .text
      align-content: center
      display: inline-flex
      font-size: 12px
      line-height: 14px
      color: #B9BFC5
      font-weight: 500
      text-transform: none
      margin-bottom: 2px
.tooltip
  opacity: 1
  pointer-events: all
  margin-left: .25rem
  i
    color: #35ACDC
    font-size: .8rem
.icon
  align-items: center
  background-color: #35acdd
  border-radius: 100%
  display: flex
  height: 36px
  justify-content: center
  width: 36px
  margin-right: 10px
  i
    color: white
    font-size: 20px

.text
  color: black
  font-size: 1rem
  padding-right: 56px

.switch
  position: absolute
  display: inline-block
  width: 40px
  height: 24px
  top: 50%
  transform: translateY(-50%)
  right: 0
  input
    opacity: 0
    width: 0
    height: 0
.slider
  border-radius: 24px
  position: absolute
  cursor: pointer
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: #ccc
  -webkit-transition: .4s
  transition: .4s
  &:before
    border-radius: 50%
    position: absolute
    content: ""
    height: 16px
    width: 16px
    left: 4px
    bottom: 4px
    background-color: white
    -webkit-transition: .4s
    transition: .4s
input
  &:checked + .slider
    background-color: #35acdd
    &:before
      -webkit-transform: translateX(16px)
      -ms-transform: translateX(16px)
      transform: translateX(16px)
  &:focus + .slider
    box-shadow: 0 0 1px #35acdd

.explanation
  color: #959595
  font-size: .9rem
  line-height: 1.25rem
  width: 100%
  padding-right: 56px
</style>
